import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _MetricPopover;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import { View } from '@instructure/ui-view';
import { CloseButton, IconButton } from '@instructure/ui-buttons';
import t from '@instructure/quiz-i18n/es/format-message';
import { IconInfoLine } from '@instructure/ui-icons';
import { Text } from '@instructure/ui-text';
import { Popover } from '@instructure/ui-popover';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import generateComponentTheme from './theme';
import generateStyle from './styles';
import PropTypes from 'prop-types';
import { withStyleOverrides } from '@instructure/quiz-common';
export var MetricPopover = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_MetricPopover = /*#__PURE__*/function (_Component) {
  function MetricPopover() {
    var _this;
    _classCallCheck(this, MetricPopover);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MetricPopover, [].concat(args));
    _defineProperty(_this, "state", {
      isContentVisible: false
    });
    _defineProperty(_this, "showPopover", function () {
      _this.setState({
        isContentVisible: true
      });
    });
    _defineProperty(_this, "hidePopover", function () {
      _this.setState({
        isContentVisible: false
      });
    });
    _defineProperty(_this, "render", function () {
      return jsx(Popover, {
        renderTrigger: _this.renderPopoverTrigger(),
        on: "click",
        screenReaderLabel: _this.props.screenReaderLabel,
        shouldContainFocus: true,
        shouldReturnFocus: true,
        onShowContent: _this.showPopover,
        onHideContent: _this.hidePopover,
        isShowingContent: _this.state.isContentVisible
      }, jsx(View, {
        padding: "medium",
        as: "div",
        display: "block",
        width: "248px"
      }, jsx("div", {
        css: _this.props.styles.closeIconContainer
      }, jsx(CloseButton, {
        onClick: _this.hidePopover,
        screenReaderLabel: t('Close popover')
      })), jsx("div", {
        css: _this.props.styles.headerContainer
      }, jsx(Heading, {
        level: "h3"
      }, _this.props.title)), jsx("div", null, _this.props.subtitle && jsx(Heading, {
        themeOverride: {
          h5FontWeight: 700
        },
        level: "h5"
      }, _this.props.subtitle), jsx(Text, {
        size: "small"
      }, _this.props.body))));
    });
    return _this;
  }
  _inherits(MetricPopover, _Component);
  return _createClass(MetricPopover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "renderPopoverTrigger",
    value: function renderPopoverTrigger() {
      return jsx(IconButton, {
        size: "small",
        themeOverride: {
          smallHeight: '18px',
          transform: 'translateY(-1px)'
        },
        withBackground: false,
        withBorder: false,
        screenReaderLabel: this.props.screenReaderLabel,
        renderIcon: jsx(IconInfoLine, {
          size: "x-small"
        })
      });
    }
  }]);
}(Component), _defineProperty(_MetricPopover, "displayName", 'MetricPopover'), _defineProperty(_MetricPopover, "componentId", "Quizzes".concat(_MetricPopover.displayName)), _defineProperty(_MetricPopover, "propTypes", {
  screenReaderLabel: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  body: PropTypes.string.isRequired,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _defineProperty(_MetricPopover, "defaultProps", {
  subtitle: ''
}), _MetricPopover)) || _class);